import { LexCusProprietaire } from "./gen-lexs";
import AbstractModel, { Model } from './abstract-model';

@Model('CavCusProprietaire')
export default class CavCusProprietaire extends AbstractModel {
  public id: number = null;
  public idCavite: string = null;
  public proprietaire: LexCusProprietaire = null;
  public commentaire: string = null;
}

